import * as _ from 'lodash'

export class Allocator {
    sumTotal: number = 0

    valueDct: { [id: string]: number } = {}
    resultDct: { [id: string]: number } = {}

    bHasChanged: boolean = true

    /** if `value` is negative, it will be defaulted to 0 */
    add(key: string, value: number) {
        if (value < 0) {
            value = 0
        }
        const dctKey = key.toString()
        if (_.isUndefined(this.valueDct[dctKey])) {
            this.valueDct[dctKey] = 0
        }
        this.valueDct[dctKey] += value
        this.sumTotal += value
        this.bHasChanged = true
    }

    /** if any `value` is negative, it will be defaulted to 0 */
    addMultiple(dct: { [id: string]: number }) {
        _.forEach(_.keys(dct), (aKey: string) => {
            this.add(aKey, dct[aKey])
        })
    }

    getPercent(key: string) {
        if (this.valueDct[key] == undefined) return 0

        if (this.sumTotal != 0 && this.bHasChanged) {
            let unAllocatedAmt: number = 1
            let smallestNonZeroValKey: string
            let smallestValue: number = Number.MAX_SAFE_INTEGER
            let largestValKey: string
            let largestValue: number = 0
            const self = this
            for (const dctKey in this.valueDct) {
                const value = self.valueDct[dctKey]
                self.resultDct[dctKey] = value / self.sumTotal
                unAllocatedAmt -= self.resultDct[dctKey]

                if (value > 0 && value < smallestValue) {
                    // only allocate to non-zero values to avoid tiny allocations
                    smallestValue = value
                    smallestNonZeroValKey = dctKey
                }
                if (value > largestValue) {
                    largestValue = value
                    largestValKey = dctKey
                }
            }

            if (unAllocatedAmt < 0) {
                self.resultDct[largestValKey] += unAllocatedAmt
            }
            if (unAllocatedAmt > 0) {
                self.resultDct[smallestNonZeroValKey] += unAllocatedAmt
            }

            this.bHasChanged = false
            return this.resultDct[key]
        } else if (this.sumTotal != 0) {
            return this.resultDct[key]
        } else {
            const count = Object.keys(this.valueDct).length
            return count != 0 ? 1 / count : 0
        }
    }

    getKeys(): string[] {
        return _.keys(this.valueDct)
    }
}
